/**
 * Template: Collection
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the collection page functionality
 *
 * @namespace collection
 */
import QuickView from '../components/quick-view';
import AdBox from '../components/ad-box';
import NostoSlider from "../components/nosto-slider";
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

/**
 * Instantiate collection modules.
 */
if (theme.features.quickview) {
    Frame.EventBus.listen('Boost:ready', () => {
        AdBox().init();
        QuickView().init();
    });
}

document.addEventListener('DOMContentLoaded', () => {
    NostoSlider().init();
});
